import styled from "styled-components";
import { device } from "../../stylesheet/breakpoints";
import { Props } from "./LayoutStartPage";

export const Box = styled.div<Props>`
  height: 100%;
  display: flex;
  justify-content: space-between;

  @media ${device.mobile} {
    flex-direction: column;

    ${({ design_type }) => {
      if (design_type === 2) {
        return `
        display: flex;
        flex-direction: row;
        flex-wrap: wrap-reverse;
        align-items: flex-end;
    `;
      }
    }}
  }

  @media ${device.desktop} {
    flex-direction: row;
  }

  ${({ design_type, image }) => {
    if ((design_type ?? 0) > 2) {
      let res = `
            position: relative;
            background-image: url(${image}); 
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            border-radius: 10px;
            `;
      if (design_type === 3) {
        res =
          res +
          `
            @media ${device.desktop} {
            margin-left: -20px;
            padding-left: 20px;
            border-radius: 0px 10px 10px 0px;
            }`;
      }
      if (design_type === 4) {
        res =
          res +
          `
            @media ${device.desktop} {
            justify-content: end;
            }`;
      }
      if (design_type === 4 || design_type === 5) {
        res =
          res +
          `
            @media ${device.desktop} {
            margin-right: -20px;
            padding-right: 20px;
            border-radius: 10px 0px 0px 10px;
        }`;
      }
      return res;
    }
    return "";
  }}
`;
